module.exports = __webpack_public_path__ + "static/media/create.95329a34.svg";